<div id="status-project" class="card-wrapper">
  <div class="card">
    <div class="card-header">
      <div class="title-row">
        <div class="title k-d-flex k-align-items-center">
          <h2 class="mb-0">Projektfortschritt</h2>
        </div>
      </div>
    </div>

    <div class="card-body container-fluid">
      <div class="row">
        <div class="col-9 k-pr-25">
          <div class="row controls">
            <div class="col k-d-flex k-justify-content-end">
              <div id="controls" class="k-d-flex k-align-items-center">
                <div id="month-and-year" class="k-text-center k-font-weight-semibold k-mr-7">
                  {{ projectProgressChartService.chartModel().startDate | date: "MMMM" }}
                  {{ projectProgressChartService.chartModel().startDate.getFullYear() }}
                </div>

                <button
                  kendoButton
                  rounded="full"
                  size="large"
                  themeColor="secondary"
                  class="k-mr-2.5"
                  [svgIcon]="chevronLeftIcon"
                  (click)="projectProgressChartService.prev()"
                ></button>

                <a
                  [routerLink]=""
                  id="today-link"
                  class="link-button k-text-center cursor-pointer"
                  (click)="projectProgressChartService.today()"
                  >Heute</a
                >

                <button
                  kendoButton
                  rounded="full"
                  size="large"
                  themeColor="secondary"
                  [svgIcon]="chevronRightIcon"
                  (click)="projectProgressChartService.next()"
                  class="k-ml-3"
                ></button>

                <kendo-dropdownlist
                  [data]="viewOptions"
                  [style.width.px]="170"
                  [value]="TimeUnits.Month"
                  [valuePrimitive]="true"
                  (selectionChange)="projectProgressChartService.switchChartView($event)"
                  textField="text"
                  valueField="value"
                  class="k-ml-7 height-inherit !k-w-auto"
                ></kendo-dropdownlist>
              </div>
            </div>

            <!-- Charts -->
            <div class="row">
              <div class="col">
                <app-project-expenditure-chart
                  [timeRange]="timeRange"
                  [timeBlocksWithTask]="timeBlocksWithTask$ | async"
                ></app-project-expenditure-chart>
              </div>
            </div>
            @if (budgetChartVisible()) {
              <div class="row">
                <div class="col">
                  <app-project-budget-chart
                    [timeRange]="timeRange"
                    [timeBlocksWithTask]="timeBlocksWithTask$ | async"
                  ></app-project-budget-chart>
                </div>
              </div>
            }
          </div>
        </div>
        <div class="col-3">
          <app-project-summary-aside
            [timeBlocksWithTask]="timeBlocksWithTask$ | async"
            [fuelBarVisible]="budgetChartVisible()"
          />
        </div>
      </div>
    </div>
  </div>

  <div style="display: grid; grid-template-columns: 1fr 1fr; column-gap: 50px">
    <div id="status-tasks" class="card-wrapper k-mt-10">
      <div class="card">
        <div class="card-header">
          <div class="title-row">
            <div class="title k-d-flex k-align-items-center">
              <h2 class="mb-0">Aufgaben</h2>
            </div>
          </div>
        </div>

        <div class="card-body container-fluid">
          <div class="row">
            <div class="col">
              <div class="table-wrapper">
                <app-project-task-summary
                  [timeBlocksWithTask]="timeBlocksWithTask$ | async"
                  [budgetVisible]="taskBudgetVisible()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="status-team" class="card-wrapper k-mt-10">
      <div class="card">
        <div class="card-header">
          <div class="title-row">
            <div class="title k-d-flex k-align-items-center">
              <h2 class="mb-0">Team</h2>
            </div>
          </div>
        </div>

        <div class="card-body container-fluid">
          <div class="row">
            <div class="col">
              <div class="table-wrapper">
                <app-project-team-summary [timeBlocksWithTask]="timeBlocksWithTask$ | async" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
